import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <label htmlFor="category-select" className="sr-only">
        Quick Select Category
      </label>
      <div className="relative">
        <select
          id="category-select"
          defaultValue=""
          onChange={handleChange}
          className="w-full appearance-none bg-transparent border-b-2 border-foreground-300 text-foreground-800 text-base py-3 pr-10 pl-1 cursor-pointer outline-none focus:border-primary-500 transition-colors font-medium"
        >
          <option value="" disabled>
            Quick Select Category
          </option>
          {categories.map((cat) => (
            <option key={cat.name} value={cat.url}>
              {cat.name}
            </option>
          ))}
        </select>
        <span className="absolute right-1 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center pointer-events-none text-foreground-400">
          <i className="ri-arrow-down-s-line text-lg"></i>
        </span>
      </div>
    </div>
  );
}